import { defineStore } from "pinia";

import modelClass from "@models/admin";
import * as getters from "@modelStores/helpers/getters-helper";

export const useAdminStore = defineStore("admin-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
